import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#141414] flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="w-8 h-8 border-2 border-[#7B2FFF] border-t-transparent rounded-full animate-spin" />
          <span className="text-sm text-[#A1A1AA] font-mono">Loading...</span>
        </div>
      </div>
    );
  }

  if (!user) {
    const target = `${location.pathname}${location.search}${location.hash}`;
    const redirect = target && target !== '/' ? `?redirect=${encodeURIComponent(target)}` : '';
    return <Navigate to={`/login${redirect}`} replace />;
  }

  return children;
}
